/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetMeOrgsResp } from './GetMeOrgsResp';
import {
    GetMeOrgsRespFromJSON,
    GetMeOrgsRespFromJSONTyped,
    GetMeOrgsRespToJSON,
} from './GetMeOrgsResp';

/**
 * 
 * @export
 * @interface GetMeOrgs200ResponseAllOf
 */
export interface GetMeOrgs200ResponseAllOf {
    /**
     * 
     * @type {GetMeOrgsResp}
     * @memberof GetMeOrgs200ResponseAllOf
     */
    result: GetMeOrgsResp;
}

/**
 * Check if a given object implements the GetMeOrgs200ResponseAllOf interface.
 */
export function instanceOfGetMeOrgs200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function GetMeOrgs200ResponseAllOfFromJSON(json: any): GetMeOrgs200ResponseAllOf {
    return GetMeOrgs200ResponseAllOfFromJSONTyped(json, false);
}

export function GetMeOrgs200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMeOrgs200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': GetMeOrgsRespFromJSON(json['result']),
    };
}

export function GetMeOrgs200ResponseAllOfToJSON(value?: GetMeOrgs200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': GetMeOrgsRespToJSON(value.result),
    };
}

